import Home from './home';
import Monitor from './monitor';
import QueueMonitor from './queue-monitor';
import Collector from './collector';

/*
type HelpDeskStatusType =
  | 'canceled'
  | 'canceled_late'
  | 'ended'
  | 'ended_late'
  | 'not_started'
  | 'not_started_late'
  | 'started'
  | 'started_late';



export type { HelpDeskStatusType };
*/
export default {
  Home,
  Monitor,
  QueueMonitor,
  Collector,
};
